(function Module() {
	'use strict';
	
   var mySynchModules = require('../config');
	var config = mySynchModules.config;
	mySynch.controller('MyFarmRanksController', [
		'$scope',
		'ApiFactory',
		'MySynchFactory',
      '$window',
      '$document',
		'$interval',
		'$filter',
      '$timeout',
      'performanceMetricsService',
      'performanceContextService',
      'clientLoggerService',
		'$q',
		function MyFarmRanksController($s ,api, MSF,$window,$document, $interval,$filter,$timeout, perfMetricSvc, perfContextSvc, log, $q) {
            $s.loading = true;
            $s.reportLoading = false;
           
            $s.userHasOnlyTestFarms = false;
          
           
            const envName = MSF.getEnvironmentName();

            
           
            $s.currentActiveHerd = MSF.getActiveHerd();
            $s.currentActiveFarm = MSF.getActiveFarm();
            $s.territoryManager = MSF.getActiveFarmTerritoryManager(); 

            let herdId = _.get($s.currentActiveHerd,'herdId',_.get($s.currentActiveFarm,'herds[0].herdId'));
            let personId = MSF.cookies.user.PersonId;

            $s.performanceContext = null;
            $s.codeFile = [];

           
            $s.rankWithinToggling = false;
            $s.rankAcrossToggling = false;
            $s.filteringByTerritory = false;

            $s.currentRankColors = [];

            $s.rankAcrossFarmsLegend = [];
            $s.rankWithinFarmLegend = [];
            $s.currentRankLegend = [];

            $s.rankAcrossFarmsLegendLabel = "Across mySYNCH Farms Rank";
            $s.rankWithinFarmLegendLabel = "Within Farm Rank (3-year)";
            $s.currentRankLegendLabel = "";
             
            $s.legendItemTmpl = {label:"",colorDivStyle:"",tooltips:[],showTooltip:false};
         
           

            var deregOnHerdChange = undefined;
            var deregTableSortableLoaded = undefined;
            var deregTableSortableDataSwapped = undefined;
            var inactivityIntervalCancel  = undefined;
         
            
            $s.tableDirectiveName = "table-sortable";
       
        $s.tableHeaders = [
                            {display:"Farm Id",showInTable:false,isIndex:true,variable:"farmId",baseVariableName:"farmId",filter:"number",filterVariable:"farmId",elementIdVariable:"farmId",headerCellClass:""},                   
                            {display:"Farm Name",showInTable:false,isIndex:false,variable:"farmName",baseVariableName:"farmName",filter:"text",filterVariable:"farmName",elementIdVariable:"farmName",headerCellClass:""},
                            {display:"Farm Name",showInTable:true,isIndex:false,hasDirective: true,variable:"popupNavMenu",baseVariableName:"farmName",filter:"text",filterVariable:"farmName",elementIdVariable:"farmName",headerCellClass:"table-sortable-farmName-header-cell"},
                            {display:"Date",showInTable:false,isIndex:false,variable:"pregRateDate",baseVariableName:"pregRateDate",filter:"dateTime",filterVariable:"pregRateDate",elementIdVariable:"farmName",headerCellClass:"table-sortable-date-header-cell"},
                            {display:"Date",showInTable:true,isIndex:false,variable:"pregRateDateDisplay",baseVariableName:"pregRateDate",filter:"dateTime",filterVariable:"pregRateDate",elementIdVariable:"farmName",headerCellClass:"table-sortable-date-header-cell"},
                            {display:"All Lact",showInTable:true,isIndex:false,variable:"pregRate9",baseVariableName:"pregRate9",filter:"percentage:1",filterVariable:"pregRate9",elementIdVariable:"farmName",headerCellClass:"table-sortable-header-cell"},
                            {display:"Lact 1",showInTable:true,isIndex:false,variable:"pregRate1",baseVariableName:"pregRate1",filter:"percentage:1",filterVariable:"pregRate1",elementIdVariable:"farmName",headerCellClass:"table-sortable-header-cell"},
                            {display:"Lact 2+",showInTable:true,isIndex:false,variable:"pregRate2",baseVariableName:"pregRate2",filter:"percentage:1",filterVariable:"pregRate2",elementIdVariable:"farmName",headerCellClass:"table-sortable-header-cell"},
                            {display:"Date",showInTable:false,isIndex:false,variable:"concepRateDate",baseVariableName:"concepRateDate",filter:"dateTime",filterVariable:"concepRateDate",elementIdVariable:"farmName",headerCellClass:"table-sortable-date-header-cell"},
                            {display:"Date",showInTable:true,isIndex:false,variable:"concepRateDateDisplay",baseVariableName:"concepRateDate",filter:"dateTime",filterVariable:"concepRateDate",elementIdVariable:"farmName",headerCellClass:"table-sortable-date-header-cell"},
                            {display:"All Lact",showInTable:true,isIndex:false,variable:"concepRate9",baseVariableName:"concepRate9",filter:"percentage:1",filterVariable:"concepRate9",elementIdVariable:"farmName",headerCellClass:"table-sortable-header-cell"},
                            {display:"Lact 1",showInTable:true,isIndex:false,variable:"concepRate1",baseVariableName:"concepRate1",filter:"percentage:1",filterVariable:"concepRate1",elementIdVariable:"farmName",headerCellClass:"table-sortable-header-cell"},
                            {display:"Lact 2+",showInTable:true,isIndex:false,variable:"concepRate2",baseVariableName:"concepRate2",filter:"percentage:1",filterVariable:"concepRate2",elementIdVariable:"farmName",headerCellClass:"table-sortable-header-cell"},
                            {display:"Date",showInTable:false,isIndex:false,variable:"insemRateDate",baseVariableName:"insemRateDate",filter:"dateTime",filterVariable:"insemRateDate",elementIdVariable:"farmName",headerCellClass:"table-sortable-date-header-cell"},
                            {display:"Date",showInTable:true,isIndex:false,variable:"insemRateDateDisplay",baseVariableName:"insemRateDate",filter:"dateTime",filterVariable:"insemRateDate",elementIdVariable:"farmName",headerCellClass:"table-sortable-date-header-cell"},
                            {display:"All Lact",showInTable:true,isIndex:false,variable:"insemRate9",baseVariableName:"insemRate9",filter:"percentage:1",filterVariable:"insemRate9",elementIdVariable:"farmName",headerCellClass:"table-sortable-header-cell"},
                            {display:"Lact 1",showInTable:true,isIndex:false,variable:"insemRate1",baseVariableName:"insemRate1",filter:"percentage:1",filterVariable:"insemRate1",elementIdVariable:"farmName",headerCellClass:"table-sortable-header-cell"},
                            {display:"Lact 2+",showInTable:true,isIndex:false,variable:"insemRate2",baseVariableName:"insemRate2",filter:"percentage:1",filterVariable:"insemRate2",elementIdVariable:"farmName",headerCellClass:"table-sortable-header-cell"}
                          ];

        $s.isSuperAdmin = _.includes(_.keys(_.get(MSF.cookies.user,'roles',{})),"SUPER_ADMIN");
        
        
        $s.defaultTerritoryFilterOptions = [{territoryManagerPersonId:0,territoryManagerLastName:"All Territories"}];
        $s.rankAcrossFarmsTerritoryFilterOptions = [];
        $s.rankWithinFarmTerritoryFilterOptions = [];
        $s.currentTerritoryFilterOptions = [];
        $s.selectedTerritoryFilterOption = 0; // 0 will be the value for All Territories

        $s.includeTestFarms = false;


        $s.currentRankView= 'RankWithinFarm';

       $s.rankWithInFarmOuterHeaderSubText = "21-Day";
       $s.rankAcrossFarmsOuterHeaderSubText = "12-mo. RHA";
       $s.currentOuterHeaderSubText = "";
        $s.rankDataTmpl =  {headers:$s.tableHeaders, tableData: []};
        $s.rankWithInFarm = _.cloneDeep($s.rankDataTmpl);
        $s.rankAcrossFarms = _.cloneDeep($s.rankDataTmpl);
        $s.currentTable = {headers:$s.tableHeaders, tableData: []};
        
        $s.rankTableItemTmpl = {farmName:"",pregRateDate:null,rhaPregDate: null,isOldPregRateDate:false,isOldRhaPregRateDate:false,hasMultiplePregRateDates:false,hasMultipleRhaPregRateDates:false,concepRateDate:null,rhaConcepDate: null,isOldConcepRateDate:false,isOldRhaConcepRateDate:false,hasMultipleConcepRateDates:false,hasMultipleRhaConcepRateDates:false,insemRateDate:null,rhaInsemDate: null,isOldRateInsemDate:false,isOldRhaInsemRateDate:false,hasMultipleInsemRateDates:false,hasMultipleRhaInsemRateDates:false,pregRate9:null,pregRate1:null,pregRate2:null,concepRate9:null,concepRate1:null,concepRate2:null,insemRate9:null,insemRate1:null,insemRate2:null,pregRate9Rank:null,pregRate1Rank:null,pregRate2Rank:null,concepRate9Rank:null,concepRate1Rank:null,concepRate2Rank:null,insemRate9Rank:null,insemRate1Rank:null,insemRate2Rank:null};
        
  

        $s.defaultSorting = {
            column: 'pregRate9', //to match the variable of one of the columns
            descending: false
        }; 
        
        
        $s.farmNamePopupNavMenuItems = [{label:"3-Year Trends",           tooltip:"View your farm&apos;s data over time and provides tools for additional analysis.",showTooltip:false, routeName:"TrendsAndTargets",permission:"THREE_YEAR_TRENDS_READ"},
                                        {label:"Seasonal Trends",         tooltip:"View your farm&apos;s data over time and provides tools for additional analysis.",showTooltip:false, routeName:"SeasonalTrends",permission:"SEASONAL_TRENDS_READ"},
                                        {label:"KPI Dashboard",           tooltip:"View your farm&apos;s current metrics.",           showTooltip:false, routeName:"KpiDashboard",permission:"KPI_DASHBOARD_READ"},
                                        {label:"Farm Goal Management",    tooltip:"Manage goals and action items for your farm.",     showTooltip:false, routeName:"FarmGoalManagement",permission:"FARM_GOAL_MANAGEMENT_READ"}
                                       ];

         
         $s.inactivityIntervalDuration = 300000; // in miliseconds.
         

           $s.consoleLog = function consoleLog(msg){
               console.log(msg);
           };

           $s.showTooltip = function showTooltip(stateVar,show){
               $s[stateVar] = show;
           };

           $s.toggleLegendTooltip = function toggleLegendTooltip(legendItem,show){
            legendItem.showTooltip = show;
           };
          $s.getConcatString = function getConcatString(value){
            var concatString = "";
            _.forEach(value.toString().split(" "),function(valPart){
                  var trimmedVal = _.trim(valPart);
                  if(!_.isEmpty(valPart)){
                     concatString += valPart;
                  }
            });
            return concatString;
          }; 
          $s.cleanFarmName = function cleanFarmName(string){
             string = string.replace("- ","");
             string = string.replace(" -","");
             string =  string.replace("'","\'");
            return string;
          };
                                        
         $s.startStopSpinner = function startStopSpinner(){
             $s.loading = !$s.loading;
         };

         $s.toggleModal = function (modalId) {
            var modal = $('#' + modalId);
            if (!modal) return;

            if (modal.is(':visible')) {
                modal.css("display", "none");
            } else {
                modal.css("display", "block");
            }
        };

        

        $s.onTerritoryFilterChange = function onTerritoryFilterChange(){
            $s.filteringByTerritory = true;
            $timeout(function(){$s.refresh();},100);
        };


        $s.toggleView = function toggleView(view){
           
            $s.currentRankView = view;
            switch (view) {
               case "RankWithinFarm":
                  $s.rankWithinToggling = true;
                  break;
               case "RankAcrossFarms":
                  $s.rankAcrossToggling = true;
                  break;
               
            }
            $timeout(function(){$s.refresh();},100);
        };

      

        $s.refresh = function refresh(){
             var nextTableData = [];
             switch($s.currentRankView){
                case "RankWithinFarm":
                   nextTableData = _.cloneDeep(_.get($s.rankWithInFarm,'tableData',[]));
                   if(!_.any($s.rankWithinFarmTerritoryFilterOptions,function(filterOption){return _.isEqual(_.get(filterOption,"territoryManagerPersonId",0),$s.selectedTerritoryFilterOption);})){
                      $s.selectedTerritoryFilterOption = 0;
                   }
                   _.set($s.currentTerritoryFilterOptions,_.cloneDeep(_.union($s.defaultTerritoryFilterOptions,$s.rankWithinFarmTerritoryFilterOptions)));
                   _.set($s.currentRankColors,_.cloneDeep($s.rankWithinFarmCodeFile));
                   $s.currentRankLegend = _.cloneDeep($s.rankWithinFarmLegend);
                   $s.currentRankLegendLabel = $s.rankWithinFarmLegendLabel;
                   $s.currentOuterHeaderSubText = $s.rankWithInFarmOuterHeaderSubText;
                break;
                case "RankAcrossFarms":
                  nextTableData = _.cloneDeep(_.get($s.rankAcrossFarms,'tableData',[]));
                  if(!_.any($s.rankAcrossFarmsTerritoryFilterOptions,function(filterOption){return _.isEqual(_.get(filterOption,"territoryManagerPersonId",0),$s.selectedTerritoryFilterOption);})){
                     $s.selectedTerritoryFilterOption = 0;
                  }
                  _.set($s.currentTerritoryFilterOptions,_.cloneDeep(_.union($s.defaultTerritoryFilterOptions,$s.rankAcrossFarmsTerritoryFilterOptions)));
                  _.set($s.currentRankColors,_.cloneDeep($s.rankAcrossFarmsCodeFile));
                  $s.currentRankLegend = _.cloneDeep($s.rankAcrossFarmsLegend);
                  $s.currentRankLegendLabel = $s.rankAcrossFarmsLegendLabel;
                  $s.currentOuterHeaderSubText = $s.rankAcrossFarmsOuterHeaderSubText;
                break;
             }

                 nextTableData = _.filter(nextTableData,function(tableDataRow) {return _.isEqual(_.get(tableDataRow,'isTestFarm',false),false);});

             if(!_.isEqual($s.selectedTerritoryFilterOption,0)){
                nextTableData = _.filter(nextTableData,function(tableDataRow) {return _.isEqual(_.get(tableDataRow,'territoryManagerPersonId',0),$s.selectedTerritoryFilterOption);});
             }

             _.set($s.currentTable,'tableData',_.cloneDeep(nextTableData));
            
          
        };

        $s.getFilteredFarmNamePopupNavMenuItems = function getFilteredFarmNamePopupNavMenuItems(myFarmsFarmDataItem) {
             var popupNavMenuItems = _.cloneDeep($s.farmNamePopupNavMenuItems); 

             // farm betas 
             var allowedBetas = []; 
                try {
                     allowedBetas = JSON.parse(_.get(myFarmsFarmDataItem,'allowedBetasJson',"[]"));
                }catch(e){ console.log("failed to parse an AllowedBetasJson farm: "+_.get(myFarmsFarmDataItem,'farmName',""));}

             popupNavMenuItems = _.compact(_.map(popupNavMenuItems, function(fnNavMenuItem) {
                                          var mappedNavMenuItem = _.cloneDeep(fnNavMenuItem);                                      
                                          if( _.isUndefined(_.get(mappedNavMenuItem,'betaReq')) || (!_.isUndefined(_.get(mappedNavMenuItem,'betaReq')) && _.any(allowedBetas,function(beta){ return _.includes(_.get(mappedNavMenuItem,'betaReq'),beta);}))){
                                                                                                               
                                                return mappedNavMenuItem;

                                          }                      
                                    }));
             return popupNavMenuItems;
        };

 
      
               
           $s.buildReportData = function buildReportData(reportData){

                var parsedReportData = JSON.parse(_.get(reportData,'data','[]'));
                //var rankWithinFarmRawData =  JSON.parse(_.get(reportData,'rankWithinFarm',"[]"));

                //var rankWithinFarmData =  _.filter(parsedReportData,{RankName: "RankWithinFarm"})
                //var rankWithinFarmData = _.filter(rankWithinFarmRawData,{FarmId: _.get($s.currentActiveFarm,'farmId')});
                var rankWithinFarmData = _.filter(parsedReportData,{RankName: "RankWithinFarm", FarmId: _.get($s.currentActiveFarm,'farmId')});

                // by default we exclude the test farms 
                _.forEach(rankWithinFarmData,function(rankRow){
                    
                    var rankTblItem = _.merge(_.clone($s.rankTableItemTmpl),MSF.lowerCaseObjectKeys(rankRow));
                    
                    _.set(rankTblItem,'id',_.get(rankRow,'FarmId'));
                    _.set(rankTblItem,'farmId',_.get(rankRow,'FarmId'));
                    _.set(rankTblItem,'farmNameOrg',_.get(rankTblItem,'farmName',""));
                    _.set(rankTblItem,'farmName',$filter("safeSpecialCharFilter")(_.get(rankTblItem,'farmName',""),"escape"));

                    var mainLabelTextColor = (_.get(rankTblItem,'isOldPregRateDate') || _.get(rankTblItem,'isOldConcepRateDate') || _.get(rankTblItem,'isOldInsemRateDate')) ? "#C2382E" : "#000000"; 
                    
                     
                    var popupNavMenu = { 
                     mainLabel: _.get(rankTblItem,'farmName'), 
                     mainLabelTextColor: mainLabelTextColor, 
                     submenuItemsJson: JSON.stringify($s.getFilteredFarmNamePopupNavMenuItems(rankTblItem)), 
                     herdId: _.get(rankTblItem,"herdId"), 
                     farmId: _.get(rankTblItem,"farmId")
                  };

                  _.set(rankTblItem,"popupNavMenu",popupNavMenu);
             
                  // Date Columns
                
                     var pregRateDateString = _.get(rankTblItem,'pregRateDate');
                     _.set(rankTblItem,'pregRateDate',moment(new Date(pregRateDateString)).toDate()); 
                     _.set(rankTblItem,'pregRateDateDisplay',_.isNull(pregRateDateString)? "" : moment(pregRateDateString).format("M/D/YY"));
                
                    var concepRateDateString = _.get(rankTblItem,'concepRateDate');
                    _.set(rankTblItem,'concepRateDate',moment(new Date(concepRateDateString)).toDate());
                    _.set(rankTblItem,'concepRateDateDisplay',_.isNull(concepRateDateString)? "" : moment(concepRateDateString).format("M/D/YY"));
                
                
                    var insemRateDateString = _.get(rankTblItem,'insemRateDate');
                    _.set(rankTblItem,'insemRateDate',moment(new Date(insemRateDateString)).toDate());
                    _.set(rankTblItem,'insemRateDateDisplay',_.isNull(insemRateDateString)? "" : moment(insemRateDateString).format("M/D/YY"));
                

                  // Body Cell Styling
                    _.set(rankTblItem,'farmNameContent_style',""); 
                    _.set(rankTblItem,'pregRateDate_style',""); 
                    _.set(rankTblItem,'concepRateDate_style',""); 
                    _.set(rankTblItem,'insemRateDate_style',"");
                     
                    _.set(rankTblItem,'pregRate9_style',`{'background-color': '${_.get(_.find($s.rankWithinFarmCodeFile,{code:_.get(rankTblItem,'pregRate9Rank')}),'detailsJson.color',"#ffffff")}' }`); 
                    _.set(rankTblItem,'pregRate1_style',`{'background-color': '${_.get(_.find($s.rankWithinFarmCodeFile,{code:_.get(rankTblItem,'pregRate1Rank')}),'detailsJson.color',"#ffffff")}' }`); 
                    _.set(rankTblItem,'pregRate2_style',`{'background-color': '${_.get(_.find($s.rankWithinFarmCodeFile,{code:_.get(rankTblItem,'pregRate2Rank')}),'detailsJson.color',"#ffffff")}' }`); 
                    _.set(rankTblItem,'concepRate9_style',`{'background-color': '${_.get(_.find($s.rankWithinFarmCodeFile,{code:_.get(rankTblItem,'concepRate9Rank')}),'detailsJson.color',"#ffffff")}' }`); 
                    _.set(rankTblItem,'concepRate1_style',`{'background-color': '${_.get(_.find($s.rankWithinFarmCodeFile,{code:_.get(rankTblItem,'concepRate1Rank')}),'detailsJson.color',"#ffffff")}' }`); 
                    _.set(rankTblItem,'concepRate2_style',`{'background-color': '${_.get(_.find($s.rankWithinFarmCodeFile,{code:_.get(rankTblItem,'concepRate2Rank')}),'detailsJson.color',"#ffffff")}' }`); 
                    _.set(rankTblItem,'insemRate9_style',`{'background-color': '${_.get(_.find($s.rankWithinFarmCodeFile,{code:_.get(rankTblItem,'insemRate9Rank')}),'detailsJson.color',"#ffffff")}' }`); 
                    _.set(rankTblItem,'insemRate1_style',`{'background-color': '${_.get(_.find($s.rankWithinFarmCodeFile,{code:_.get(rankTblItem,'insemRate1Rank')}),'detailsJson.color',"#ffffff")}' }`); 
                    _.set(rankTblItem,'insemRate2_style',`{'background-color': '${_.get(_.find($s.rankWithinFarmCodeFile,{code:_.get(rankTblItem,'insemRate2Rank')}),'detailsJson.color',"#ffffff")}' }`); 
                    

                  // Body Cell Tooltips
                  _.set(rankTblItem,'pregRateDate_isOld',_.get(rankTblItem,'isOldPregRateDate'));
                  _.set(rankTblItem,'pregRateDate_hasMultipleDates',_.get(rankTblItem,'hasMultiplePregRateDates'));
                  _.set(rankTblItem,'pregRateDate_showTooltip',false);
                  var pregRateDateToolTip = "The most recent date for your farm's reproductive rates differs across lactation groups. The date displayed in your My Farms dashboard has been summarized and is the most recent date across all lactation groups. If you have questions, please contact your Parnell Territory Manager.";
                  if(_.isEqual(_.get(rankTblItem,'isOldPregRateDate'),true)){
                     pregRateDateToolTip = "There is is an issue with the currency of this farm’s data. Interpret carefully and contact your Parnell Territory Manager.";
                  }
                  _.set(rankTblItem,'pregRateDate_tooltip',pregRateDateToolTip);

                  _.set(rankTblItem,'concepRateDate_isOld',_.get(rankTblItem,'isOldConcepRateDate'));
                  _.set(rankTblItem,'concepRateDate_hasMultipleDates',_.get(rankTblItem,'hasMultipleConcepRateDates'));
                  _.set(rankTblItem,'concepRateDate_showTooltip',false);
                  var concepRateDateToolTip = "The most recent date for your farm's reproductive rates differs across lactation groups. The date displayed in your My Farms dashboard has been summarized and is the most recent date across all lactation groups. If you have questions, please contact your Parnell Territory Manager.";
                  if(_.isEqual(_.get(rankTblItem,'isOldConcepRateDate'),true)){
                     concepRateDateToolTip = "There is is an issue with the currency of this farm’s data. Interpret carefully and contact your Parnell Territory Manager.";
                  }
                  _.set(rankTblItem,'concepRateDate_tooltip',concepRateDateToolTip);

                  _.set(rankTblItem,'insemRateDate_isOld',_.get(rankTblItem,'isOldInsemRateDate'));
                  _.set(rankTblItem,'insemRateDate_hasMultipleDates',_.get(rankTblItem,'hasMultipleInsemRateDates'));
                  _.set(rankTblItem,'insemRateDate_showTooltip',false);
                  var insemRateDateToolTip = "The most recent date for your farm's reproductive rates differs across lactation groups. The date displayed in your My Farms dashboard has been summarized and is the most recent date across all lactation groups. If you have questions, please contact your Parnell Territory Manager.";
                  if(_.isEqual(_.get(rankTblItem,'isOldInsemRateDate'),true)){
                     insemRateDateToolTip = "There is is an issue with the currency of this farm’s data. Interpret carefully and contact your Parnell Territory Manager.";
                  }
                  _.set(rankTblItem,'insemRateDate_tooltip',insemRateDateToolTip);

                    $s.rankWithInFarm.tableData.push(rankTblItem);
 
                });

                //var rankAcrossFarmsRawData =  JSON.parse(_.get(reportData,'rankAcrossFarms',"[]"));
                var rankAcrossFarmsData  = _.filter(parsedReportData,{RankName: "RankAcrossFarms", FarmId: _.get($s.currentActiveFarm,'farmId')});

               // by default we exclude the test farms 
          

                _.forEach(rankAcrossFarmsData,function(rankRow){
                    var rankTblItem = _.merge(_.clone($s.rankTableItemTmpl),MSF.lowerCaseObjectKeys(rankRow));

                    _.set(rankTblItem,'id',_.get(rankRow,'FarmId'));
                    _.set(rankTblItem,'farmId',_.get(rankRow,'FarmId'));
                    _.set(rankTblItem,'farmNameOrg',_.get(rankTblItem,'farmName',""));
                    _.set(rankTblItem,'farmName',$filter("safeSpecialCharFilter")(_.get(rankTblItem,'farmName',""),"escape"));

                    var mainLabelTextColor = (_.get(rankTblItem,'isOldRhaPregRateDate') || _.get(rankTblItem,'isOldRhaConcepRateDate') || _.get(rankTblItem,'isOldRhaInsemRateDate')) ? "#C2382E" : "#000000"; 
                  
                     var popupNavMenu = {
                        mainLabel: _.get(rankTblItem,'farmName'),
                        mainLabelTextColor: mainLabelTextColor,
                        submenuItemsJson: JSON.stringify($s.getFilteredFarmNamePopupNavMenuItems(rankTblItem)),
                        herdId: _.get(rankTblItem,"herdId"),
                        farmId: _.get(rankTblItem,"farmId")
                     }
                     _.set(rankTblItem,"popupNavMenu",popupNavMenu);
                     
                  
                  
                   // Date Columns
               
                     var pregRateDateString = _.get(rankTblItem,'rhaPregDate');
                     _.set(rankTblItem,'pregRateDate',moment(new Date(pregRateDateString)).toDate()); 
                     _.set(rankTblItem,'pregRateDateDisplay',_.isNull(pregRateDateString)? "" : moment(pregRateDateString).format("M/D/YY"));
                 
                    var concepRateDateString = _.get(rankTblItem,'rhaConcepDate');
                    _.set(rankTblItem,'concepRateDate',moment(new Date(concepRateDateString)).toDate());
                    _.set(rankTblItem,'concepRateDateDisplay',_.isNull(concepRateDateString)? "" : moment(concepRateDateString).format("M/D/YY"));
               
          
                    var insemRateDateString = _.get(rankTblItem,'rhaInsemDate');
                    _.set(rankTblItem,'insemRateDate',moment(new Date(insemRateDateString)).toDate());
                    _.set(rankTblItem,'insemRateDateDisplay',_.isNull(insemRateDateString)? "" : moment(insemRateDateString).format("M/D/YY"));
               

                  _.set(rankTblItem,'farmNameContent_style',""); 
                  _.set(rankTblItem,'pregRateDate_style',""); 
                  _.set(rankTblItem,'concepRateDate_style',""); 
                  _.set(rankTblItem,'insemRateDate_style',"");
                    _.set(rankTblItem,'pregRate9_style',`{'background-color': '${_.get(_.find($s.rankAcrossFarmsCodeFile,{code:_.get(rankTblItem,'pregRate9Rank')}),'detailsJson.color',"#ffffff")}' }`); 
                    _.set(rankTblItem,'pregRate1_style',`{'background-color': '${_.get(_.find($s.rankAcrossFarmsCodeFile,{code:_.get(rankTblItem,'pregRate1Rank')}),'detailsJson.color',"#ffffff")}' }`); 
                    _.set(rankTblItem,'pregRate2_style',`{'background-color': '${_.get(_.find($s.rankAcrossFarmsCodeFile,{code:_.get(rankTblItem,'pregRate2Rank')}),'detailsJson.color',"#ffffff")}' }`); 
                    _.set(rankTblItem,'concepRate9_style',`{'background-color': '${_.get(_.find($s.rankAcrossFarmsCodeFile,{code:_.get(rankTblItem,'concepRate9Rank')}),'detailsJson.color',"#ffffff")}' }`); 
                    _.set(rankTblItem,'concepRate1_style',`{'background-color': '${_.get(_.find($s.rankAcrossFarmsCodeFile,{code:_.get(rankTblItem,'concepRate1Rank')}),'detailsJson.color',"#ffffff")}' }`); 
                    _.set(rankTblItem,'concepRate2_style',`{'background-color': '${_.get(_.find($s.rankAcrossFarmsCodeFile,{code:_.get(rankTblItem,'concepRate2Rank')}),'detailsJson.color',"#ffffff")}' }`); 
                    _.set(rankTblItem,'insemRate9_style',`{'background-color': '${_.get(_.find($s.rankAcrossFarmsCodeFile,{code:_.get(rankTblItem,'insemRate9Rank')}),'detailsJson.color',"#ffffff")}' }`); 
                    _.set(rankTblItem,'insemRate1_style',`{'background-color': '${_.get(_.find($s.rankAcrossFarmsCodeFile,{code:_.get(rankTblItem,'insemRate1Rank')}),'detailsJson.color',"#ffffff")}' }`); 
                    _.set(rankTblItem,'insemRate2_style',`{'background-color': '${_.get(_.find($s.rankAcrossFarmsCodeFile,{code:_.get(rankTblItem,'insemRate2Rank')}),'detailsJson.color',"#ffffff")}' }`);

                   
                   // Body Cell Tooltips
                  _.set(rankTblItem,'pregRateDate_isOld',_.get(rankTblItem,'isOldRhaPregRateDate'));
                  _.set(rankTblItem,'pregRateDate_hasMultipleDates',_.get(rankTblItem,'hasMultipleRhaPregRateDates'));
                  _.set(rankTblItem,'pregRateDate_showTooltip',false);
                  var rhaPregRateDateToolTip = "The most recent date for your farm's reproductive rates differs across lactation groups. The date displayed in your My Farms dashboard has been summarized and is the most recent date across all lactation groups. If you have questions, please contact your Parnell Territory Manager.";
                  if(_.isEqual(_.get(rankTblItem,'isOldRhaPregRateDate'),true)){
                     rhaPregRateDateToolTip = "There is is an issue with the currency of this farm’s data. Interpret carefully and contact your Parnell Territory Manager.";
                  }
                  _.set(rankTblItem,'pregRateDate_tooltip',rhaPregRateDateToolTip);
                 
                  _.set(rankTblItem,'concepRateDate_isOld',_.get(rankTblItem,'isOldRhaConcepRateDate'));
                  _.set(rankTblItem,'concepRateDate_hasMultipleDates',_.get(rankTblItem,'hasMultipleRhaConcepRateDates'));
                  _.set(rankTblItem,'concepRateDate_showTooltip',false);
                  var rhaConcepRateDateToolTip = "The most recent date for your farm's reproductive rates differs across lactation groups. The date displayed in your My Farms dashboard has been summarized and is the most recent date across all lactation groups. If you have questions, please contact your Parnell Territory Manager.";
                  if(_.isEqual(_.get(rankTblItem,'isOldRhaConcepRateDate'),true)){
                     rhaConcepRateDateToolTip = "There is is an issue with the currency of this farm’s data. Interpret carefully and contact your Parnell Territory Manager.";
                  }
                  _.set(rankTblItem,'concepRateDate_tooltip',rhaConcepRateDateToolTip);
                 
                  _.set(rankTblItem,'insemRateDate_isOld',_.get(rankTblItem,'isOldRhaInsemRateDate'));
                  _.set(rankTblItem,'insemRateDate_hasMultipleDates',_.get(rankTblItem,'hasMultipleRhaInsemRateDates'));
                  _.set(rankTblItem,'insemRateDate_showTooltip',false);
                  var rhaInsemRateDateToolTip = "The most recent date for your farm's reproductive rates differs across lactation groups. The date displayed in your My Farms dashboard has been summarized and is the most recent date across all lactation groups. If you have questions, please contact your Parnell Territory Manager.";
                  if(_.isEqual(_.get(rankTblItem,'isOldRhaInsemRateDate'),true)){
                     rhaInsemRateDateToolTip = "There is is an issue with the currency of this farm’s data. Interpret carefully and contact your Parnell Territory Manager.";
                  }
                  _.set(rankTblItem,'insemRateDate_tooltip',rhaInsemRateDateToolTip);

                   
                    $s.rankAcrossFarms.tableData.push(rankTblItem);
                });
           
            
                // by default we exclude the test farms 
                _.set($s.currentTable,'tableData', _.filter(_.get($s.currentTable,"tableData",[]),function(rankDataRow){return _.isEqual(_.get(rankDataRow,'isTestFarm',false),false);}));

                
                $s.currentRankColors = _.cloneDeep($s.rankWithinFarmCodeFile);


                _.forEach($s.rankWithinFarmCodeFile,function(rankWithinCodeFileItem){
                     var legendItem = _.cloneDeep($s.legendItemTmpl);
                     _.set(legendItem,'label',_.get(rankWithinCodeFileItem,'codeValue'));
                     _.set(legendItem,'colorDivStyle',`{'background-color': '${_.get(rankWithinCodeFileItem,'detailsJson.color')}'}`);
                     _.set(legendItem,'tooltips',_.get(rankWithinCodeFileItem,'detailsJson.tooltips'));
                     $s.rankWithinFarmLegend.push(legendItem);
                });

                _.forEach($s.rankAcrossFarmsCodeFile,function(rankAcrossCodeFileItem){
                  var legendItem = _.cloneDeep($s.legendItemTmpl);
                  _.set(legendItem,'label',_.get(rankAcrossCodeFileItem,'codeValue'));
                  _.set(legendItem,'colorDivStyle',`{'background-color': '${_.get(rankAcrossCodeFileItem,'detailsJson.color')}'}`);
                  _.set(legendItem,'tooltips',_.get(rankAcrossCodeFileItem,'detailsJson.tooltips'));
                  $s.rankAcrossFarmsLegend.push(legendItem);
             });

             $s.currentRankLegend = _.cloneDeep($s.rankWithinFarmLegend);

             $s.currentRankLegendLabel = $s.rankWithinFarmLegendLabel;

             $s.currentOuterHeaderSubText = $s.rankWithInFarmOuterHeaderSubText;
                
                
                $s.rankWithinFarmTerritoryFilterOptions = _.union(_.cloneDeep(
                                                                     _.sortByOrder(
                                                                     _.uniq( 
                                                                        _.map($s.rankWithInFarm.tableData,function(tableDataRow)
                                                                              {
                                                                                 return _.pick(tableDataRow,["territoryManagerLastName","territoryManagerPersonId"]);
                                                                              })
                                                                     , "territoryManagerPersonId")
                                                                     ,["territoryManagerLastName"])
                                                                   )
                                                                   ,$s.defaultTerritoryFilterOptions );
                $s.rankAcrossFarmsTerritoryFilterOptions = _.union(_.cloneDeep(
                                                                  _.sortByOrder( 
                                                                     _.uniq( 
                                                                       _.map($s.rankAcrossFarms.tableData,function(tableDataRow)
                                                                            {
                                                                                return _.pick(tableDataRow,["territoryManagerLastName","territoryManagerPersonId"]);
                                                                            })
                                                                     , "territoryManagerPersonId")
                                                                  ,["territoryManagerLastName"])
                                                                ) 
                                                                ,$s.defaultTerritoryFilterOptions);
                  
                  $s.currentTerritoryFilterOptions = _.cloneDeep($s.rankWithinFarmTerritoryFilterOptions);

                  if($s.isSuperAdmin){
                     $s.selectedTerritoryFilterOption = _.get(_.first($s.currentTerritoryFilterOptions),'territoryManagerPersonId');
                  }
                   var inititalTable = _.cloneDeep($s.rankWithInFarm);
                  $s.currentTable = inititalTable;

                  $s.loading = false;
               
           }; 

                 
           $s.loadReports = function loadReports(){
               const loadReportsPromise = $q.defer();
           
               perfMetricSvc.startTiming("Page:MyFarmRanksPageData:Request");
              //for now this page is using the same data as the MultiFarmDashboard. Eventually it will use a different api.
              api.getMultiFarmDashboard(personId, $s.performanceContext, function(error,multiFarmDashboardData){
                  perfMetricSvc.endTiming("page","Page:MyFarmRanksPageData:Request", $s.performanceContext);
                
                  perfMetricSvc.startTiming("Page:MyFarmRanks:Build");
                  $s.buildReportData(multiFarmDashboardData);
                  perfMetricSvc.endTiming("page","Page:MyFarmRanks:Build", $s.performanceContext);

                  loadReportsPromise.resolve();
             
              });

              return loadReportsPromise.promise;
           };

           $s.stopInactivityInterval = function stopInactivityInterval(){
            //(`Inactivity Interval was stopped at ${moment().toDate()}`)
               if(!_.isUndefined(inactivityIntervalCancel)){
                  $interval.cancel(inactivityIntervalCancel);
            
               }

           };

           $s.resetInactivityInterval = function resetInactivityInterval(){
         
                 if(!_.isUndefined(inactivityIntervalCancel)){
                      $interval.cancel(inactivityIntervalCancel);
                      
                 }

                 inactivityIntervalCancel = $interval(function(){
                                              $s.toggleModal("inactivityModal");
                                              $s.disableInactivityWatchersAndTimers();
                                           },$s.inactivityIntervalDuration);

              
             
           };

           $s.onInactivityContinue = function onInactivityContinue(){
                $s.toggleModal("inactivityModal");
                $s.enableInactivityWatchersAndTimers();
           };

           $s.enableInactivityWatchersAndTimers = function enableInactivityWatchersAndTimers(){
              
              $document.on("click",function(){
                  $s.resetInactivityInterval();
              });

              $window.onscroll = function(){
                  $s.resetInactivityInterval();
              };

              $(".outer-table-container").on("scroll",function(){
                  $s.resetInactivityInterval();
                  
              });
              
              $document.on("mousemove",function(){
                   $s.resetInactivityInterval();
              });

              inactivityIntervalCancel = $interval(function(){
                   $s.toggleModal("inactivityModal");
                   $s.disableInactivityWatchersAndTimers();
              },$s.inactivityIntervalDuration);

           };

           $s.disableInactivityWatchersAndTimers = function disableInactivityWatchersAndTimers(){
               $document.off("click");
               $window.onscroll = null;
               $(".outer-table-container").off("scroll");
               $document.off("mousemove");
               $s.stopInactivityInterval();
           };

           $s.resetReportData = function resetReportData(){
              $s.rankWithInFarm = _.cloneDeep($s.rankDataTmpl);
              $s.rankAcrossFarms = _.cloneDeep($s.rankDataTmpl);
              $s.rankAcrossFarmsLegend = [];
              $s.rankWithinFarmLegend = [];
           }

           $s.$on("$destroy", function() {
			
            log.info("my farm ranks destroy called");
      
         
            if(!_.isUndefined(deregOnHerdChange)) {deregOnHerdChange();}

            if(!_.isUndefined(deregTableSortableLoaded)) {deregTableSortableLoaded();}

            if(!_.isUndefined(deregTableSortableDataSwapped)) {deregTableSortableDataSwapped();}

            $s.disableInactivityWatchersAndTimers();

            $s.performanceContext = null;
         });

        deregTableSortableLoaded = $s.$on("table-sortable:loaded",function(scope,eventData){
              var breakpoint = "";
         });

         deregTableSortableDataSwapped = $s.$on("table-sortable:data-swapped",function(scope,eventData){
            ///multi-farm-dashboard-view

                  $s.rankWithinToggling = false;  
                  $s.rankAcrossToggling = false;
                  $s.filteringByTerritory = false;

         });

          
            MSF.ready(function onMsfReady() {
        
               $s.loading = true;
               $s.codeFile =  _.cloneDeep(_.get(MSF,"lists.codeFile",[])); 
               $s.rankWithinFarmCodeFile = _.forEach(_.filter($s.codeFile,{codeType:"RANKMFDBWITHIN"}),function(codeFileMFDRankItem){
                                                
                                                _.set(codeFileMFDRankItem,'code',Number(_.get(codeFileMFDRankItem,'code')));
                                                var detailsJson = {};
                                                try{
                                                   detailsJson = _.get(JSON.parse(_.get(codeFileMFDRankItem,'detailsJson',"{}")),"[0]");
                                                }catch(e){
                                                   console.log("failed to parse a RANKMFDBWITHIN codefile entry's detailsJson");
                                                }
                                                _.set(codeFileMFDRankItem,"detailsJson",detailsJson);
                                                
                                          }); 


               $s.rankAcrossFarmsCodeFile = _.forEach(_.filter($s.codeFile,{codeType:"RANKMFDBACROSS"}),function(codeFileMFDRankItem){
                                                   _.set(codeFileMFDRankItem,'code',Number(_.get(codeFileMFDRankItem,'code')));                                 
                                                   var detailsJson = {};
                                                   try{
                                                      detailsJson = _.get(JSON.parse(_.get(codeFileMFDRankItem,'detailsJson',"{}")),"[0]");
                                                   }catch(e){
                                                      console.log("failed to parse a RANKMFDBACROSS codefile entry's detailsJson");
                                                   }
                                                   _.set(codeFileMFDRankItem,"detailsJson",detailsJson);
                                          });
                 herdId = _.get($s.currentActiveHerd,'herdId',_.get($s.currentActiveFarm,'herds[0].herdId'));
                  
                 $s.userHasOnlyTestFarms = MSF.userHasTestFarmsOnly();
                 if(_.isEqual($s.userHasOnlyTestFarms,false)){
                  $s.performanceContext = perfContextSvc.createPerformanceContext(_.get($s.currentActiveHerd,'herdId',null));
                     perfMetricSvc.startTiming("Page:MyFarmRanks:Render");
                        $s.enableInactivityWatchersAndTimers();

                        $s.loadReports().then(() => {
                           perfMetricSvc.markPageReady("Page:MyFarmRanks:Render", $s.performanceContext);
                        });
                 }else{
                  $s.loading = false;
                 }
                 

               deregOnHerdChange =   $s.$on('herd:changed', function(){
                  $s.disableInactivityWatchersAndTimers();
                  $s.resetReportData();
                  
                  $s.loading = true;
                  $s.currentActiveHerd = MSF.getActiveHerd();
                  $s.currentActiveFarm = MSF.getActiveFarm();

                  $s.userHasOnlyTestFarms = MSF.userHasTestFarmsOnly();
                  

                  if(_.isEqual($s.userHasOnlyTestFarms,false)){
                     perfMetricSvc.startTiming("Page:MyFarmRanksOnHerdChange:Render");
                     $s.performanceContext = perfContextSvc.createPerformanceContext(_.get($s.currentActiveHerd,'herdId',null));
                         $s.enableInactivityWatchersAndTimers();

                         $s.loadReports().then(() => {
                            perfMetricSvc.markPageReady("Page:MyFarmRanksOnHerdChange:Render", $s.performanceContext);
                         });
                  }else{
                   $s.loading = false;
                  }


               });
                

            });
            		 
		}
	]);
})();
